// ---------------------------------------------------------------------------
// BR Code Pix (EMV) — gera o payload padrao Banco Central para QR estatico.
//
// O dinheiro vai DIRETO do aluno para a chave do professor: a plataforma
// apenas formata a informacao, nunca intermedia o pagamento.
//
// Modulo puro, formato da API: sem React, sem estado, sem rede.
// ---------------------------------------------------------------------------

// CRC16-CCITT-FALSE (poly 0x1021, init 0xFFFF) — exigido pelo padrao EMV
function crc16(str) {
  let crc = 0xFFFF;
  for (let i = 0; i < str.length; i++) {
    crc ^= str.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = (crc & 0x8000) ? ((crc << 1) ^ 0x1021) : (crc << 1);
      crc &= 0xFFFF;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

function campo(id, valor) {
  const v = String(valor);
  return id + String(v.length).padStart(2, '0') + v;
}

// remove acentos e caracteres fora do basico; corta no limite do padrao
function sanear(txt, max) {
  return String(txt || '')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9 .-]/g, '')
    .toUpperCase().trim().slice(0, max) || 'N I';
}

// txid do QR estatico (padrao do Banco Central): so' letras e numeros, ate' 25. Hifen, ponto
// ou espaco fazem alguns bancos recusarem o QR. Vazio = '***' (o "sem identificador" do padrao).
export function limparTxid(txid) {
  const t = String(txid == null ? '' : txid).replace(/[^A-Za-z0-9]/g, '').slice(0, 25);
  return t || '***';
}

/**
 * Gera o payload copia-e-cola / QR do Pix.
 * @param {object} p
 * @param {string} p.chave  — chave Pix do RECEBEDOR (email, cpf, telefone +55..., aleatoria)
 * @param {string} p.nome   — nome do recebedor (max 25 no padrao)
 * @param {string} [p.cidade='SAO PAULO'] — max 15
 * @param {number} [p.valor] — se omitido, o pagador digita o valor
 * @param {string} [p.txid='***'] — identificador: so' letras e numeros, max 25 (o resto e' tirado)
 */
export function gerarBRCode({ chave, nome, cidade = 'SAO PAULO', valor, txid = '***' }) {
  if (!chave || !String(chave).trim()) return { erro: 'Chave Pix não cadastrada.' };

  const conta = campo('00', 'br.gov.bcb.pix') + campo('01', String(chave).trim());
  let payload =
    campo('00', '01') +
    campo('26', conta) +
    campo('52', '0000') +
    campo('53', '986');
  if (valor != null && Number(valor) > 0) payload += campo('54', Number(valor).toFixed(2));
  payload +=
    campo('58', 'BR') +
    campo('59', sanear(nome, 25)) +
    campo('60', sanear(cidade, 15)) +
    campo('62', campo('05', limparTxid(txid)));
  payload += '6304';
  payload += crc16(payload);
  return { payload };
}
